__turbopack_context__.v({
  "compact": "IndicatorsContainer-module-scss-module__n1y7Nq__compact",
  "dark": "IndicatorsContainer-module-scss-module__n1y7Nq__dark",
  "hotKey": "IndicatorsContainer-module-scss-module__n1y7Nq__hotKey",
  "indicatorsContainer": "IndicatorsContainer-module-scss-module__n1y7Nq__indicatorsContainer",
  "text": "IndicatorsContainer-module-scss-module__n1y7Nq__text",
});
